import moment from 'moment';
import momentTz from 'moment-timezone';
import 'moment/locale/id';

// Add custom configuration here
moment.locale('id');
momentTz.locale('id');

export { moment, momentTz };
